<template>
    <div id="catalog">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">作业预览</p>
        </div>
        <template v-if="loading">
            <div class="content">
                <p class="prompting"
                   v-show="closeFlag">视频只有开通的学生可以观看
                    <!--<i class="icon-fou" @click="close()"></i>-->
                </p>
                <noResouse v-if="!question.length"></noResouse>
                <div class="list-wrap"
                     v-else>
                    <dl class="list"
                        v-for="q in question">
                        <dt>{{q.name}}</dt>
                        <dd v-for="item in q.list"
                            @click="open(item.video_url)">
                            <span class="icon-play"></span>
                            <p>{{item.name}}</p>
                        </dd>
                    </dl>
                </div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <videoPlayer v-if="!inApp"
            ref="videoPlayer"
            @closePlayer="closePlayer"
            v-show="playFlag"
            :video_url="videourl"
            submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'SRC/components/base/tealoading.vue';
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    data () {
        return {
            taskId: this.$route.params.taskid,
            closeFlag: true,
            question: [],
            loading: false,
        }
    },
    created () {
        this.$http.get(API_URL_TASK_API + '/maths/check/video/preview?message_id=' + this.taskId).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.question = this.question.concat(res.data);
            }
            this.$nextTick(() => {
                this.loading = true;
            })
        })
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
        close () {
            this.closeFlag = false;
        },
        /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
        open (arg) {
            // try {
            //   appobject.Interactive('ys_video,' + arg);
            // } catch (e) {
            //   layer.open({
            //     title: '提示',
            //     content: '请下载同步课堂客户端，体验更多功能！<br />下载地址：http://m.tbkt.cn',
            //     btn: '确定',
            //     yes: function () {
            //       layer.closeAll();
            //     }
            //   });
            // }
            
            if (this.inApp) {
                this.appFunction("ys_video", arg);
            } else {
                this.videourl = arg;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
                return
            }
        }
    },
    components: {
        noResouse, loadingS,videoPlayer
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 96px / $ppr;
        background: #5e89ef;

        .back {
            position: absolute;
            top: 0;
            left: 0;
            width: 76px / $ppr;
            height: 96px / $ppr;
            background: url(./img/choose_back.png) no-repeat center;
            background-size: 18px / $ppr 34px / $ppr;
        }

        .title {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 34px / $ppr;
            color: #fff;
            text-align: center;
        }
    }
    .content {
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 28px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 0;
                right: 40px / $ppr;
                &:before {
                    color: #ccc;
                    content: "X";
                }
            }
        }

        .list-wrap {
            .list {
                margin-top: 24px / $ppr;
                background-color: #fff;
                dt {
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    font-weight: 600;
                }
                dd {
                    position: relative;
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;

                    color: #333;
                    border-top: 1px / $ppr solid #e8e8e8;
                    display: flex;
                    display: -webkit-flex;
                    align-items: center;
                    -webkit-align-items: center;
                    .icon-play {
                        width: 40px / $ppr;
                        height: 40px / $ppr;
                        background-image: url(img/icon_video.png);
                        background-size: contain;
                    }
                    p {
                        font-size: 30px / $ppr;
                        color: #555;
                        padding-left: 24px / $ppr;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        flex: 1;
                        -webkit-flex: 1;
                    }
                }
            }
        }
    }
}
</style>
